
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $9YEav = parcelRequire("9YEav");
parcelRequire("fJThW");

var $a9ZSp = parcelRequire("a9ZSp");

var $hHIOY = parcelRequire("hHIOY");
var $e2pZd = parcelRequire("e2pZd");
var $d5S8e = parcelRequire("d5S8e");
var $2wrqp = parcelRequire("2wrqp");
var $9MfiC = parcelRequire("9MfiC");

var $6ACgD = parcelRequire("6ACgD");
window.$ = (0, (/*@__PURE__*/$parcel$interopDefault($9YEav)));
const $5c4c1d088edc38ec$var$anchorParams = new Proxy(new URLSearchParams(window.location.hash.replace("#", "")), {
    get: (anchorParams, prop)=>anchorParams.get(prop)
});
const $5c4c1d088edc38ec$var$TYPESENSE_SERVER_CONFIG = {
    apiKey: "3FE6XjoV2QHVjUyVdXs4eh4aw8MduZY8",
    nodes: [
        {
            host: $5c4c1d088edc38ec$var$anchorParams.host ? $5c4c1d088edc38ec$var$anchorParams.host : "searchbible.net",
            port: "443",
            protocol: "https",
            path: '/api/ts'
        }
    ],
    numRetries: 8,
    useServerSideSearchCache: false
};
const $5c4c1d088edc38ec$var$INDEX_NAME = "kjvbible2026";
const $5c4c1d088edc38ec$var$typesenseInstantsearchAdapter = new (0, (/*@__PURE__*/$parcel$interopDefault($6ACgD)))({
    server: $5c4c1d088edc38ec$var$TYPESENSE_SERVER_CONFIG,
    additionalSearchParameters: {
        query_by: "vtext,emojis",
        facet_sample_threshold: 1000,
        facet_sample_percent: 20
    }
});
const $5c4c1d088edc38ec$var$searchClient = $5c4c1d088edc38ec$var$typesenseInstantsearchAdapter.searchClient;
const $5c4c1d088edc38ec$var$search = (0, $a9ZSp.default)({
    searchClient: $5c4c1d088edc38ec$var$searchClient,
    indexName: $5c4c1d088edc38ec$var$INDEX_NAME,
    future: {
        preserveSharedStateOnUnmount: true
    }
});
// Emoji lookup map
const $5c4c1d088edc38ec$var$EMOJI_MAP = {
    "Abundance": "\uD83C\uDF3E",
    "Adoration": "\uD83D\uDE0D",
    "Alms": "\uD83D\uDCB5",
    "Anointing": "\uD83E\uDDF4",
    "Ascension": "\u2B06\uFE0F",
    "Atonement": "\uD83E\uDE78",
    "Beatitude": "\uD83C\uDF3A",
    "Benevolence": "\uD83C\uDF97\uFE0F",
    "Blessing": "\uD83C\uDF81",
    "Bliss": "\uD83D\uDE0C",
    "Charity": "\uD83E\uDD32",
    "Comfort": "\uD83D\uDC9A",
    "Commitment": "\u270A",
    "Communion": "\uD83C\uDF77",
    "Compassion": "\uD83D\uDC95",
    "Consecration": "\uD83D\uDCAB",
    "Contemplation": "\uD83D\uDCAD",
    "Contentment": "\u262E\uFE0F",
    "Contrition": "\uD83D\uDE1E",
    "Courage": "\u2694\uFE0F",
    "Covenant": "\uD83D\uDCDC",
    "Dedication": "\uD83C\uDF96\uFE0F",
    "Deliverance": "\uD83D\uDDDD\uFE0F",
    "Destiny": "\uD83E\uDDED",
    "Devotion": "\uD83D\uDCFF",
    "Discernment": "\uD83D\uDC41\uFE0F",
    "Discipleship": "\uD83D\uDC68\u200D\uD83C\uDFEB",
    "Divinity": "\u2600\uFE0F",
    "Endurance": "\uD83D\uDCAF",
    "Eternity": "\u267E\uFE0F",
    "Exaltation": "\uD83C\uDF1F",
    "Faith": "\uD83D\uDCD6",
    "Fate": "\u2693",
    "Favor": "\uD83C\uDF19",
    "Fellowship": "\uD83D\uDC65",
    "Forgiveness": "\uD83D\uDD6F\uFE0F",
    "Fulfillment": "\uD83C\uDFC5",
    "Glorification": "\uD83D\uDC51",
    "Glory": "\uD83E\uDD47",
    "Grace": "\u2728",
    "Guardianship": "\uD83D\uDD12",
    "Healing": "\uD83C\uDF3F",
    "Holiness": "\uD83D\uDD4C",
    "Hope": "\uD83C\uDF05",
    "Hospitality": "\uD83D\uDEAA",
    "Humility": "\uD83D\uDE47",
    "Immortality": "\uD83D\uDC7B",
    "Integrity": "\uD83D\uDCCF",
    "Intercession": "\uD83D\uDCE3",
    "Joy": "\uD83D\uDE0A",
    "Justification": "\u2714\uFE0F",
    "Light": "\uD83C\uDF20",
    "Longsuffering": "\u23F3",
    "Love": "\u2764\uFE0F",
    "Loyalty": "\uD83D\uDC8E",
    "Meditation": "\uD83E\uDDD8",
    "Meekness": "\uD83E\uDDA2",
    "Mercy": "\uD83D\uDC9D",
    "Nurture": "\uD83C\uDF3C",
    "Obedience": "\u270B",
    "Peace": "\uD83D\uDD4A\uFE0F",
    "Perseverance": "\uD83C\uDFC3",
    "Petition": "\uD83D\uDCDD",
    "Piety": "\uD83C\uDFDB\uFE0F",
    "Praise": "\uD83D\uDE4C",
    "Prayer": "\uD83D\uDE4F",
    "Predestination": "\uD83D\uDDFA\uFE0F",
    "Prosperity": "\uD83D\uDCB0",
    "Protection": "\uD83D\uDEE1\uFE0F",
    "Providence": "\uD83C\uDFB0",
    "Provision": "\uD83C\uDF5E",
    "Purity": "\uD83E\uDD0D",
    "Reconciliation": "\uD83D\uDD17",
    "Redemption": "\uD83D\uDD13",
    "Refuge": "\uD83C\uDFF0",
    "Renewal": "\uD83C\uDF31",
    "Repentance": "\uD83D\uDE14",
    "Restoration": "\uD83D\uDD27",
    "Resurrection": "\uD83D\uDD04",
    "Reverence": "\uD83C\uDFAD",
    "Righteousness": "\u2B50",
    "Sacredness": "\u26E9\uFE0F",
    "Sacrifice": "\uD83D\uDC80",
    "Salvation": "\u271D\uFE0F",
    "Sanctification": "\uD83D\uDD2E",
    "Sanctity": "\uD83D\uDD14",
    "Sanctuary": "\u26EA",
    "Self-Control": "\uD83C\uDFB2",
    "Serenity": "\uD83C\uDF0A",
    "Shepherding": "\uD83D\uDC11",
    "Sovereignty": "\uD83E\uDD85",
    "Spirituality": "\uD83C\uDF0C",
    "Steadfastness": "\uD83E\uDEA8",
    "Stewardship": "\uD83C\uDFE0",
    "Strength": "\uD83D\uDCAA",
    "Submission": "\uD83D\uDE47\u200D\u2640\uFE0F",
    "Supplication": "\uD83E\uDD7A",
    "Surrender": "\uD83C\uDFF3\uFE0F",
    "Sustenance": "\uD83C\uDF7D\uFE0F",
    "Testimony": "\uD83D\uDCE2",
    "Thanksgiving": "\uD83C\uDF89",
    "Transfiguration": "\uD83C\uDF08",
    "Transformation": "\uD83E\uDD8B",
    "Trust": "\uD83E\uDD1D",
    "Truth": "\uD83D\uDD26",
    "Unity": "\uD83D\uDC50",
    "Victory": "\uD83E\uDD47",
    "Virtue": "\uD83D\uDC7C",
    "Wisdom": "\uD83E\uDD89",
    "Witness": "\uD83D\uDC40",
    "Worship": "\uD83C\uDFB5",
    "Counsel": "\uD83D\uDCAC",
    "Faithfulness": "\u2705",
    "Fortitude": "\uD83E\uDD81",
    "Gentleness": "\uD83C\uDF38",
    "Goodness": "\uD83D\uDE07",
    "Justice": "\u2696\uFE0F",
    "Kindness": "\uD83E\uDD17",
    "Knowledge": "\uD83D\uDCDA",
    "Patience": "\u23F0",
    "Prudence": "\uD83E\uDDE0",
    "Temperance": "\uD83C\uDFAF",
    "Understanding": "\uD83D\uDCA1",
    "Angry": "\uD83D\uDE20",
    "Fearful": "\uD83D\uDE28",
    "Triumphant": "\uD83C\uDFC6",
    "Serious": "\uD83D\uDE10",
    "Joyful": "\uD83D\uDE0A",
    "Anxious": "\uD83D\uDE30",
    "Sad": "\uD83D\uDE22",
    "Warm": "\uD83E\uDD17",
    "Relieved": "\uD83D\uDE0C",
    "Amazed": "\uD83D\uDE32",
    "Celebratory": "\uD83C\uDF89",
    "Frustrated": "\uD83D\uDE24",
    "Pleading": "\uD83E\uDD7A",
    "Solemn": "\uD83D\uDE14",
    "Hopeful": "\uD83C\uDF05",
    "Disappointed": "\uD83D\uDE1E",
    "Worried": "\uD83D\uDE1F",
    "Determined": "\uD83D\uDCAA",
    "Furious": "\uD83E\uDD2C",
    "Tender": "\uD83D\uDC95",
    "Delighted": "\uD83D\uDE04",
    "Shocked": "\uD83D\uDE31",
    "Stern": "\uD83D\uDE20",
    "Skeptical": "\uD83E\uDD28",
    "Nervous": "\uD83D\uDE2C",
    "Excited": "\uD83E\uDD29",
    "Inquisitive": "\uD83E\uDD14",
    "Happy": "\uD83D\uDE0A",
    "Caring": "\uD83E\uDD17",
    "Deceitful": "\uD83E\uDD25",
    "Encouraging": "\uD83D\uDC4D",
    "Reverent": "\uD83D\uDE4F",
    "Confident": "\uD83D\uDE0E",
    "Pleasant": "\uD83D\uDE0A",
    "Affectionate": "\uD83E\uDD70",
    "Somber": "\uD83D\uDE14",
    "Authoritative": "\uD83D\uDC6E",
    "Reassuring": "\uD83E\uDD1D",
    "Cheerful": "\uD83D\uDE04",
    "Deadly": "\uD83D\uDC80",
    "Earnest": "\uD83D\uDE24",
    "Peaceful": "\uD83D\uDD4A\uFE0F",
    "Disgusted": "\uD83E\uDD22",
    "Confused": "\uD83D\uDE15",
    "Loving": "\uD83D\uDC95",
    "Crying": "\uD83D\uDE2D",
    "Instructive": "\uD83D\uDC68\u200D\uD83C\uDFEB",
    "Adoring": "\uD83D\uDE0D",
    "Ominous": "\u26A1",
    "Dismissive": "\uD83D\uDE44",
    "Surprised": "\uD83D\uDE2E",
    "Disapproving": "\uD83D\uDC4E",
    "Annoyed": "\uD83D\uDE12",
    "Commanding": "\uD83D\uDC49",
    "Astonished": "\uD83D\uDE32",
    "Devilish": "\uD83D\uDE08",
    "Smug": "\uD83D\uDE0F",
    "Exhausted": "\uD83D\uDE2B",
    "Cautionary": "\u26A0\uFE0F",
    "Grateful": "\uD83D\uDE4F",
    "Calm": "\uD83D\uDE0C",
    "Mischievous": "\uD83D\uDE0F",
    "Embarrassed": "\uD83D\uDE33",
    "Defiant": "\u270A",
    "Grim": "\u2620\uFE0F",
    "Urgent": "\uD83D\uDD34",
    "Focused": "\uD83D\uDC41\uFE0F",
    "Humble": "\uD83D\uDE0C",
    "Resolute": "\uD83D\uDC4A",
    "Resigned": "\uD83D\uDE14",
    "Generous": "\uD83C\uDF81",
    "Desperate": "\uD83D\uDE29",
    "Mysterious": "\uD83C\uDFAD",
    "Admiring": "\uD83E\uDD29",
    "Contemptuous": "\uD83D\uDE44",
    "Tired": "\uD83D\uDE34",
    "Emphatic": "\uD83D\uDCAF",
    "Proud": "\uD83E\uDD81",
    "Threatening": "\u2694\uFE0F",
    "Playful": "\uD83C\uDFAE",
    "Firm": "\uD83D\uDCAA",
    "Greedy": "\uD83E\uDD11",
    "Hostile": "\uD83D\uDE20",
    "Neutral": "\uD83D\uDE10",
    "Creation": "\uD83C\uDF0D",
    "Gospel": "\uD83D\uDCF0",
    "Prophecy": "\uD83D\uDDE3\uFE0F",
    "Kingdom": "\uD83C\uDFF0",
    "Persecution": "\u26D3\uFE0F",
    "Parable": "\uD83C\uDFA8",
    "Sacrament": "\uD83C\uDF77",
    "Tithes": "\uD83E\uDE99",
    "Disciple": "\uD83D\uDC63",
    "Sin": "\u274C",
    "Temptation": "\uD83C\uDF4E"
};
$5c4c1d088edc38ec$var$search.addWidgets([
    (0, $hHIOY.default)({
        hitsPerPage: 20,
        query: ""
    }),
    (0, $9MfiC.default)({
        container: "#stats",
        templates: {
            text: ({ nbHits: nbHits, hasNoResults: hasNoResults, hasOneResult: hasOneResult, processingTimeMS: processingTimeMS })=>{
                if (hasNoResults) return "No results";
                if (hasOneResult) return `1 result in ${processingTimeMS}ms`;
                return `\u{2728} ${nbHits.toLocaleString()} results in ${processingTimeMS}ms`;
            }
        }
    }),
    (0, $d5S8e.default)({
        container: "#hits",
        cssClasses: {
            list: "list-unstyled",
            item: "d-flex flex-column p-3 resultscolor",
            loadMore: "btn btn-primary mx-auto d-block mt-4"
        },
        templates: {
            item: (hit, { html: html, components: components })=>html`
        <div class="mb-0">
          <a href="https://www.kingjamesbibleonline.org/${hit.bname.replace(/ /g, '-')}-${hit.cnum}-${hit.vnum}/" target="_blank">
            <b class='dred'>${hit.bname} ${hit.cnum}:${hit.vnum}</b>
          </a><br />
          <span style="color:black;font-size:1.1rem;">${components.Highlight({
                    hit: hit,
                    attribute: "vtext"
                })}</span>
        </div>
      `,
            empty: (state, { html: html })=>html`No results found. Try selecting a different emotion.`
        }
    }),
    (0, $2wrqp.default)({
        container: "#emojis-refinement-list",
        attribute: "emojis",
        searchable: true,
        searchablePlaceholder: "Search emotions...",
        showMore: true,
        showMoreLimit: 200,
        limit: 30,
        sortBy: [
            "name:asc"
        ],
        cssClasses: {
            searchableInput: "form-control form-control-sm mb-2 border-light-2",
            searchableSubmit: "d-none",
            searchableReset: "d-none",
            showMore: "btn btn-secondary btn-sm align-content-center",
            list: "list-unstyled",
            count: "badge bg-light text-bg-light ms-2",
            label: "d-flex align-items-center text-capitalize mb-2",
            checkbox: "me-2"
        }
    }),
    (0, $e2pZd.default)({
        container: "#current-refinements",
        cssClasses: {
            list: "list-unstyled",
            label: "d-none",
            item: "h5",
            category: "badge bg-light text-bg-light px-3 m-2",
            categoryLabel: "text-capitalize",
            delete: "btn btn-sm btn-link p-0 ps-2"
        },
        transformItems: (items)=>items.map((item)=>({
                    ...item,
                    label: ""
                }))
    })
]);
$5c4c1d088edc38ec$var$search.start();
$(function() {
    $5c4c1d088edc38ec$var$search.helper.setQuery("").search();
});


//# sourceMappingURL=emotions.d6384070.js.map
